import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const StatusRejectedIcon = ({ type = 'utility', size = 'regular', disabled = false, color, styles }) => {
    const { colors, sizing } = useTheme();
    color = color || getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { width: sizePx, height: sizePx, viewBox: "0 0 20 20", fill: "none", style: styles },
        React.createElement("g", { clipPath: "url(#clip0_53_19992)", strokeWidth: "1", strokeMiterlimit: "10", strokeLinecap: "round", stroke: color },
            React.createElement("path", { d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" }),
            React.createElement("path", { d: "M6 10H14" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_53_20000" },
                React.createElement("rect", { width: "20", height: "20", fill: "white" })))));
};
export default StatusRejectedIcon;
//# sourceMappingURL=index.js.map